export const getJSBasePath = () => {
  let filenames = [
    'sdk/analytics-sdk.js',
    `sdk/analytics-sdk.debug.js`,
    'src/analytics-sdk.js',
  ];
  let currentPath = '';

  let currScriptName;
  let scripts = document.getElementsByTagName('script');
  let surl = '';
  for (let si = 0; si < scripts.length; si++) {
    let src = scripts[si].src && scripts[si].src;
    if (src) {
      for (let fi = 0; fi < filenames.length; fi++) {
        let isPresent = ~src.indexOf(filenames[fi]);

        if (isPresent) {
          surl = src;
          currScriptName = filenames[fi];
          break;
        }
      }
    }
    if (currScriptName) {
      break;
    }
  }
  currentPath = surl.substring(0, surl.indexOf(currScriptName));
  return currentPath;
};

export const loadJS = (url, callback) => {
  try {
    var script = document.createElement('script');
    script.src = url;
    script.addEventListener('load', function () {
      if (typeof callback === 'function') callback();
    });
    document.head.appendChild(script);
  } catch (error) {
    console.info(error);
  }
};
